﻿import { Button } from '@progress/kendo-react-buttons';
import { SvgIcon } from '@progress/kendo-react-common';
import { useNavigate } from 'react-router';
import { CogOutline, ExternalLinkOutline } from '../../../../../icons/icons';
import { EliService } from '../../../../../services/external-link-interface/EliService';
import CustomPopover from '../../../../components/layout/CustomPopover';
import { useAppSelector } from '../../../../hooks/store-hooks';
import { ROUTES } from '../../../../router/routes';
import { SETTINGS_ROUTES } from '../../../settings/router/settings-routes';

export function EliToolbarItem() {
    const eliButtons = useAppSelector((x) => x.settings.eliTopBarButtons);
    const navigate = useNavigate();
    return (
        <CustomPopover
            title="External Link Interface"
            trigger={
                <Button
                    style={{
                        width: 27,
                        height: 27
                    }}
                    className="k-rounded-full"
                    data-tooltip-bottom
                    svgIcon={ExternalLinkOutline}
                    id="eli-toolbar-btn"
                />
            }>
            <div className="d-flex flex-column gap-0" style={{ fontSize: 12, width: 180 }}>
                {eliButtons.map((btn) => (
                    <div className="clickable px-2 py-1 d-flex align-items-center gap-2" onClick={() => EliService.handleTopBar(btn)}>
                        <div style={{ width: 16, height: 16 }}></div>
                        {btn.label}
                    </div>
                ))}
                <div
                    className="clickable px-2 py-1 d-flex align-items-center gap-2 border-top"
                    onClick={() => navigate(`${ROUTES.SETTINGS}/${SETTINGS_ROUTES.externalLinkIntegration}`)}>
                    <SvgIcon icon={CogOutline} />
                    {eliButtons.length === 0 ? 'Add custom buttons' : 'Manage custom buttons'}
                </div>
            </div>
        </CustomPopover>
    );
}
